var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "fuel-funds__vendor-list--item" }, [
    _c("span", { staticClass: "fuel-funds__vendor-list--percent" }, [
      _vm._v(_vm._s(_vm.vendor.percent) + "%")
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "fuel-funds__vendor-list--vendor" }, [
      _vm._v(_vm._s(_vm.vendor.vendor))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }